import { render, staticRenderFns } from "./RiskBars.vue?vue&type=template&id=d40e94b8&scoped=true"
import script from "./RiskBars.vue?vue&type=script&lang=js"
export * from "./RiskBars.vue?vue&type=script&lang=js"
import style0 from "./RiskBars.vue?vue&type=style&index=0&id=d40e94b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40e94b8",
  null
  
)

export default component.exports